<template>
  <div v-if="ticketAttachments.length > 0" class="file-downloader-container">
    <div class="title">{{ intl[$store.state.lang]["title"] }}</div>
    <div class="files-container">
      <div class="accordion" :id="'accordionAttachment-accordion-'+i" v-for="(attachmentsType,i) in Object.keys(ticketAttachmentsTypes)" :key="i">
        <div class="accordion-item">
          <h2 class="accordion-header" :id="'accordionAttachment-heading-'+i">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#accordionAttachment-'+i"
              aria-expanded="true"
              :aria-controls="'accordionAttachment-'+i"
            >
              {{ attachmentsType }}
            </button>
          </h2>
          <div
            :id="'accordionAttachment-'+i"
            class="accordion-collapse collapse show"
            :aria-labelledby="'accordionAttachment-heading-'+i"
          >
            <div class="attachment"  v-for="(attachment, index) in ticketAttachmentsTypes[attachmentsType]" :key="attachment.id">
                <div :onclick="() => {downloadAttachment(attachment)}">{{  intl[$store.state.lang]["attachment"] + "("+(index + 1) +")" }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";

export default {
  name: "ticketAttachmentFileDownloader",
  mounted() {},
  components: {},
  props: {
    ticketId: {
      type: Number,
      default: null,
    },
    setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {
              //console.log("FILE DOWNLOADER LOADER: ",value)
              return
            },
      },
  },
  created() {
    if (this.ticketId) {
        this.loader = true
      axios
        .get(apiUrls["ticket_detail"] + this.ticketId)
        .then((response) => {
          if (response && response.data && response.data.ticketAttachments) {
            let attachmentsTypes = {}
            response.data.ticketAttachments.map((attachment,i) => {
              if (attachment.type in attachmentsTypes) {
                    attachmentsTypes[attachment.type].push(attachment)
                } else {
                    attachmentsTypes[attachment.type] = [attachment]
                }
            })
            this.ticketAttachments = response.data.ticketAttachments;
            this.ticketAttachmentsTypes = attachmentsTypes;
          }
          this.loader = false
        })
        .catch((error) => {

            this.loader = false
        });
    }
  },

  data: function () {
    return {
        apiUrls: apiUrls,
        intl: intl,
        ticketAttachments: [],
        loader: false
    };
  },
  methods: {
    base64ToFile(base64String, fileName) {
      const byteCharacters = atob(base64String);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteArray], {
        type: 'application/octet-stream'
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.click();
      URL.revokeObjectURL(url);
    },
    
    downloadAttachment(attachment) {
        if(attachment.id && attachment.path){
            this.loader = true
            axios
        .get(apiUrls["download_ticket_attachment_file"] + attachment.id)
            .then((response) => {
                this.base64ToFile(response.data.content,response.data.original_filename)
                this.loader = false
            })
            .catch((error) => {
                this.loader = false
            }); 
        }
        
    },
  },
  watch: {
      loader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({ticketAttachmentFileDownloaderLoader: newValue})
                    }                
                },
                immediate: true, 
        },
  },
  computed: {},
};
</script>
